import { Box, Typography } from "@mui/material";
import CheckedMark from "assets/icons/checked-mark.svg";
import UncheckedMark from "assets/icons/unchecked-mark.svg";
import { Business } from "lib/features/business/types";
import { createBusinessListStyles } from "styles/BusinessListDirectory/createBusinessList.styles";
import { getBusinessImageSource } from "util/getImageSource";

interface BusinesslistCardProps {
  business: Business;
  selectedBusinesses: Business[];
  handleBusinessRecords: (business: Business, action: boolean) => void;
}

const BusinesslistCard = ({
  business,
  selectedBusinesses,
  handleBusinessRecords,
}: BusinesslistCardProps) => {
  const isSelected = selectedBusinesses.some((item) => item.id === business.id);

  const toggleCheck = () => {
    handleBusinessRecords(business, !isSelected);
  };

  return (
    <Box sx={createBusinessListStyles.card}>
      {/* Image and Star Icon */}
      <Box sx={createBusinessListStyles.imageContainer}>
        <img
          style={createBusinessListStyles.image}
          src={getBusinessImageSource(business)}
        />

        <Box sx={createBusinessListStyles.favoriteIcon} onClick={toggleCheck}>
          {isSelected ? (
            <img src={CheckedMark} width={17} height={17} />
          ) : (
            <img src={UncheckedMark} width={17} height={17} />
          )}
        </Box>
      </Box>

      {/* Business Details */}
      <Box sx={createBusinessListStyles.contentContainer}>
        <Typography sx={createBusinessListStyles.title}>
          {business?.business}
        </Typography>
        {business?.address1 && (
          <Typography sx={createBusinessListStyles.address}>
            {business?.address1}
          </Typography>
        )}

        <Typography sx={createBusinessListStyles.description}>
          {business?.business_headline}
        </Typography>
      </Box>
    </Box>
  );
};

export default BusinesslistCard;
